(function () {
  var FILLED_CART_SVG =
    '<svg class="cart-icon-filled-svg" viewBox="0 0 24 24" height="30" width="30" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path fill="#e62f76" d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.47 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>' +
    '<text class="cart-count-in-svg" x="12.7" y="11.6" text-anchor="middle" font-size="8" font-weight="bold" font-family="Arial, sans-serif" fill="#ffffff"></text>' +
    '</svg>';

  function ensureFilledIcon(btn) {
    if (!btn.querySelector('.cart-icon-filled-svg')) {
      var outline = btn.querySelector('svg');
      if (outline) {
        outline.insertAdjacentHTML('afterend', FILLED_CART_SVG);
      }
    }
  }

  function updateCartIconState() {
    document.querySelectorAll('.js-cart-count').forEach(function (countEl) {
      var btn = countEl.closest('.cart-icon');
      if (!btn) return;
      ensureFilledIcon(btn);
      var count = parseInt(countEl.textContent, 10) || 0;
      btn.classList.toggle('has-items', count > 0);
      var svgText = btn.querySelector('.cart-count-in-svg');
      if (svgText) {
        svgText.textContent = count > 0 ? String(count) : '';
        svgText.setAttribute('font-size', count > 9 ? '6.5' : '8');
      }
    });
  }

  updateCartIconState();
  document.querySelectorAll('.js-cart-count').forEach(function (countEl) {
    new MutationObserver(updateCartIconState).observe(countEl, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });
  document.addEventListener('DOMContentLoaded', updateCartIconState);
})();
